import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], filter: Object): any {
    if (!items || !filter) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => this.applyFilter(item, filter));
  }

  /**
   * Perform the filtering.
   *
   * @param item The item to compare to the filter.
   * @param filter The filter to apply.
   * @return True if item satisfies filters, false if not.
   */
  applyFilter(item: any, filter: any): boolean {
    for (const field in filter) {
      if (filter[field]) {
        const itemValue = field.includes('|') ? item[field.split('|')[0]][field.split('|')[1]] : item[field];
        if (typeof filter[field] === 'string') {
          if (itemValue.toLowerCase().indexOf(filter[field].toLowerCase()) === -1) {
            return false;
          }
        } else if (typeof filter[field] === 'number') {
          if (itemValue !== filter[field]) {
            return false;
          }
        }
      }
    }
    return true;
  }

}
